export default "__VITE_ASSET__112jG475__"